import request from '@/utils/request'
import appRequest from '@/utils/appRequest'
import Qs from 'qs'

import ZCRequest from '@/utils/zhichongRequest'

/**
 * 发起支付（V3.6）
 * → POST /payCon/v2/userOrderPay/placeAnOrderV2
 * 兼容旧页面读取 result / h5_url / code_url / qr_code 等字段
 */
export function placeAnOrder(params = {}) {
  const payload = { ...params }
  Object.keys(payload).forEach(key => {
    if (payload[key] === undefined) delete payload[key]
  })
  return request({
    url: '/payCon/v2/userOrderPay/placeAnOrderV2',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: Qs.stringify(payload)
  }).then(res => {
    if (res && res.code == 200 && res.data && typeof res.data === 'object') {
      const data = res.data
      return {
        ...res,
        data: {
          ...data,
          result:
            data.result != null
              ? data.result
              : data.payUrl || data.h5_url || data.h5Url || data.qrCode || data.codeUrl || data.code_url,
          h5_url: data.h5_url || data.h5Url || data.payUrl || data.result,
          code_url: data.code_url || data.codeUrl || data.result,
          qr_code: data.qr_code || data.qrCode || data.qr_url || data.qrUrl || data.result,
          qr_url: data.qr_url || data.qrUrl || data.qr_code || data.qrCode || data.result
        }
      }
    }
    return res
  })
}

// 前端 支付状态查询
export function checkPay(params) {
  return request({
    url: '/payCon/userOrderPay/checkPay',
    method: 'post',
    noLoading:true,
    params
  })
}
// APP 支付状态
export function appcheckPay(data) {
  return appRequest({
    url: 'v342/Topup/selectKbz',
    method: 'post',
    noLoading:true,
    data
  })
}

// 直充支付状态查询

export function ZCcheckPay(data) {
  return ZCRequest({
    url: 'v342/Topup/selectKbz',
    method: 'post',
    noLoading:true,
    data
  })
}

// 餐饮订单支付下单
export function cateringOrderPlaceAnOrder(params) {
  return request({
      url: '/payCon/cateringOrderPay/cateringPlaceAnOrder',
      method: 'post',
      params
  })
}

// 餐饮订单支付查询
export function cateringOrderCheck(params) {
  return request({
      url: '/payCon/cateringOrderPay/cateringOrderCheck',
      method: 'post',
      noLoading:true,
      params
  })
}

// 全球充订单支付下单（前端唤起支付）
export function payPhoneRechargeConsume(params) {
  return request({
    url: '/payCon/userOrderPay/pay4PhoneRechargeConsume',
    method: 'post',
    params
  })
}